import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { Link } from '@tanstack/react-router';
import { addon, SHOP_PLANS } from '@fsp/core';
import { api, type Me } from '../api';
import { errorText, useI18n } from '../i18n';
import { Icon, type IconName } from '../icons';
import { Alert, PageHead, PanelShell } from '../layout';

type States = Record<string, { enabled: boolean; interested: boolean }>;

/** A menu tab that is not built yet: what it will do, the plan it is meant for, and "tell me when it is ready". */
export function SoonPage({ me, id }: { me: Me; id: string }) {
  const { t } = useI18n();
  const queryClient = useQueryClient();
  const item = addon(id);
  const shop = useQuery({ queryKey: ['shop-all'], queryFn: () => api.get<{ addons: States; unavailable: string[] }>('api/v1/shop') });
  const interested = Boolean(shop.data?.addons[id]?.interested);
  const act = useMutation({
    mutationFn: (value: boolean) => api.put(`api/v1/shop/addons/${id}/interest`, { interested: value }),
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['shop-all'] }),
  });
  if (!item || item.status !== 'soon') {
    return <PanelShell me={me} head={<PageHead eyebrow={t('Netrukus')} title={t('Puslapis nerastas')} />}><p className="muted">{t('Tokio puslapio nėra.')}</p></PanelShell>;
  }
  const plan = SHOP_PLANS.find((p) => p.id === item.plan);
  return (
    <PanelShell me={me} head={<PageHead eyebrow={t('Netrukus')} title={t(item.name)} text={t(item.text)} />}>
      <section className="panel-card soon-card">
        <span className="shop-addon-icon"><Icon name={item.icon as IconName} /></span>
        <div>
          <h2>{t(item.name)} <span className="shop-tag">{t('Netrukus')}</span></h2>
          <p>{t(item.text)}</p>
          {plan ? <p className="muted">{t('Bus plane: {plan}', { plan: plan.name })}</p> : null}
          {act.isError ? <Alert kind="error">{errorText(t, act.error)}</Alert> : null}
          <div className="soon-actions">
            <button type="button" className={`button button--small ${interested ? 'button--ghost' : 'button--primary'}`} disabled={!shop.data || act.isPending || Boolean(me.viewAsAdmin)}
              onClick={() => act.mutate(!interested)}>
              {interested ? t('✓ Pranešime') : t('Pranešti, kai bus')}
            </button>
            <Link to="/shop" className="button button--ghost button--small">{t('Visi planai ir priedai')}</Link>
          </div>
        </div>
      </section>
    </PanelShell>
  );
}
